import React from 'react';
import useStyle from './tableMyResultCarouselText.style';

export interface TableMyResultCarouselTextProps {
  name: string;
  value: string | number;
  classValue: string | number;
}

export const TableMyResultCarouselText = ({
  name,
  value,
  classValue
}: TableMyResultCarouselTextProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <span>{name}</span>
      <span className={classes.large}>{value}</span>
      <div>
        <span>Classe : </span>
        <span className={classes.bold}>{classValue}</span>
      </div>
    </div>
  );
};
